import React from 'react';
import ReactDOM from 'react-dom';
import {
  DOMWidgetModel,
  DOMWidgetView,
  ISerializers,
} from '@jupyter-widgets/base';

import { FeatureId } from '@models/feature';
import { FeatureLeaderboard } from '@models/feature-leaderboard';
import { WidgetModelContextProvider } from '@utils/widget-model';
import { WidgetApi, ResponseEvent } from '@utils/widget-api';
import { MODULE_NAME, MODULE_VERSION } from '../version';
import { FeatureLeaderboardView } from './feature-leaderboard/FeatureLeaderboardView';

// Python state from feature_leaderboard_widget.py
export interface FeatureLeaderboardWidgetState {
  value: FeatureLeaderboard;
  confidence: number;
  max_collinearity: number;
  liked_features: FeatureId[];
  disliked_features: FeatureId[];
}

const defaultState = {
  value: { allEntries: [], tableColumns: {} },
  confidence: 0.95,
  max_collinearity: 0.95,
  liked_features: [],
  disliked_features: [],
} satisfies FeatureLeaderboardWidgetState;

export class FeatureLeaderboardWidgetModel extends DOMWidgetModel {
  defaults() {
    return {
      ...super.defaults(),
      _model_name: 'FeatureLeaderboardWidgetModel',
      _model_module: MODULE_NAME,
      _model_module_version: MODULE_VERSION,
      _view_name: 'FeatureLeaderboardWidgetView',
      _view_module: MODULE_NAME,
      _view_module_version: MODULE_VERSION,
      ...defaultState,
    };
  }

  static serializers: ISerializers = {
    ...DOMWidgetModel.serializers,
  };
}

export class FeatureLeaderboardWidgetView extends DOMWidgetView {
  render() {
    this.el.classList.add('dotdata-widget');
    this.el.classList.add('feature-leaderboard-widget');

    try {
      const component = React.createElement(
        WidgetModelContextProvider(FeatureLeaderboardView),
        {
          model: this.model,
        }
      );
      ReactDOM.render(component, this.el);
    } catch (err) {
      console.error('FeatureSpaceWidgetView', err);
    }
  }

  events() {
    return {
      create_feature: 'create_feature',
      set_user_explanation: 'set_user_explanation',
    };
  }

  handle_message(event: ResponseEvent) {
    WidgetApi.handleEvent(event);
  }
}
